import { ConfigProvider, message } from 'antd';
import axios from 'axios';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { IS_PROD } from 'constants/isProd';
import { PRIMARY_COLOR } from 'constants/theme';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'store';
import { refreshTokenGen } from 'store/reducers/authReducer';

import ruRU from 'antd/lib/locale/ru_RU';
import 'dayjs/locale/ru';
import './index.css';

import App from './App';

export const setupAxios = () => {
  const token = localStorage.getItem('token');
  axios.defaults.baseURL = `${process.env.REACT_APP_HOSTNAME}/api/`;

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (
        (err.response?.status === 401) &
        (err.response.request.responseURL !==
          `${process.env.REACT_APP_HOSTNAME}/api/token/generate/`)
      ) {
        store.dispatch(refreshTokenGen());
      }

      if (err.response?.data?.detail) {
        const { status, detail } = err.response.data;
        const detailText =
          typeof detail === 'string' ? detail : JSON.stringify(detail);
        const text = status ? `${status}: ${detailText}` : detailText;
        if (err.response?.status !== 403) {
          message.error(text);
        }
        if (err.response?.data?.detail?.alert?.text) {
          message.error(err.response?.data?.detail?.alert?.text);
        }
      }
      return Promise.reject(err);
    }
  );
};

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  debug: !IS_PROD,
  ignore_dnt: true,
});
setupAxios();

ConfigProvider.config({
  theme: {
    primaryColor: PRIMARY_COLOR,
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: PRIMARY_COLOR,
          },
          components: {
            Typography: {
              colorLink: PRIMARY_COLOR,
              colorLinkHover: '#ffbb45',
              colorLinkActive: PRIMARY_COLOR,
              colorTextDisabled: '#ffeebf',
              colorPrimaryHover: '#ffbb45',
            },
          },
        }}
        locale={ruRU}
      >
        <Provider store={store}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
